import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PresencasEstudantesLayer from "../components/PresencasEstudantesLayer";
import { useTranslation } from "../i18n/I18nContext";

const PresencasEstudantesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("presenca.breadcrumb")} />
      <PresencasEstudantesLayer />
    </MasterLayout>
  );
};

export default PresencasEstudantesPage;
